export const anchorLinks = () => {
  const $anchorLinks = document.querySelector("section.anchor-links");
  if ($anchorLinks) {
    const $anchorLinksDropdown = $anchorLinks.querySelector(
      ".anchor-links__dropdown"
    );
    const $dropdownButton =
      $anchorLinksDropdown.querySelector(".dropdown__button");
    const $buttonIcon = $dropdownButton.querySelector(".button__icon");
    const $iconOpen = $buttonIcon.querySelector(".icon__open");
    const $iconClosed = $buttonIcon.querySelector(".icon__closed");

    const $dropdownItems =
      $anchorLinksDropdown.querySelector(".dropdown__items");

    $dropdownButton.addEventListener("click", (event) => {
      event.preventDefault();
      if (
        $anchorLinksDropdown.classList.contains(
          "anchor-links__dropdown--active"
        )
      ) {
        $anchorLinksDropdown.classList.remove("anchor-links__dropdown--active");
        $iconOpen.classList.add("hidden");
        $iconClosed.classList.remove("hidden");
        $dropdownItems.classList.add("hidden");
      } else {
        $anchorLinksDropdown.classList.add("anchor-links__dropdown--active");
        $iconOpen.classList.remove("hidden");
        $iconClosed.classList.add("hidden");
        $dropdownItems.classList.remove("hidden");
      }
    });

    const $dropdownItemsLinks = $dropdownItems.querySelectorAll(
      ".dropdown__item .item__link"
    );
    $dropdownItemsLinks.forEach(($dropdownItemsLink) => {
      $dropdownItemsLink.addEventListener("click", (event) => {
        $anchorLinksDropdown.classList.remove("anchor-links__dropdown--active");
        $iconOpen.classList.add("hidden");
        $iconClosed.classList.remove("hidden");
        $dropdownItems.classList.add("hidden");
      });
    });
  }
};

export default anchorLinks;
